import '../styles/Loader.css'

const Loader = () => <div className="center-loader"><div className="lds-ripple"><div></div><div></div></div></div>
    

export default Loader;